module.exports = require('./lib/axios');


//////////////////
// WEBPACK FOOTER
// ./~/firebase-paginator/~/axios/index.js
// module id = 708
// module chunks = 0